import React, { Component } from "react";
import { HashRouter, Route, Routes, BrowserRouter } from "react-router-dom";
import "./scss/style.scss";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthContextProvider } from "./common/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import APIErrorProvider from "./context/APIErrorContext";
import APIErrorNotification from "./components/APIErrorNotification";
import { LocaleProvider } from "./context/LocaleContext";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const ForgotPassword = React.lazy(() =>
  import("./views/pages/password/ForgotPassword")
);
const CheckoutForm = React.lazy(() => import("./views/pages/payment/Payment"));
const Receipt = React.lazy(() => import("./views/pages/payment/Receipt"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));

/* eslint-disable react/prop-types */
class App extends Component {
  render() {
    return (
      <BrowserRouter>
        {/* <Suspense fallback={loading}> */}
        <AuthContextProvider>
          <APIErrorProvider>
            <LocaleProvider>
              <Routes>
                <Route
                  exact
                  path="/login"
                  name="Login Page"
                  element={
                    <ProtectedRoute accessBy="non-authenticated">
                      <Login />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/forgot-password"
                  name="Forgot password"
                  element={
                    <ProtectedRoute accessBy="non-authenticated">
                      <ForgotPassword />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/payment/:locationId"
                  name="Payment Page"
                  element={<CheckoutForm />}
                />
                <Route
                  exact
                  path="/receipt/:locationId/:ticketId"
                  name="Receipt Page"
                  element={<Receipt />}
                />
                <Route
                  exact
                  path="/404"
                  name="Page 404"
                  element={<Page404 />}
                />
                <Route
                  exact
                  path="/500"
                  name="Page 500"
                  element={<Page500 />}
                />
                <Route
                  path="*"
                  name="Home"
                  element={
                    <ProtectedRoute accessBy="authenticated">
                      <DefaultLayout />
                    </ProtectedRoute>
                  }
                />
              </Routes>
              {/*<APIErrorNotification />*/}
              <ToastContainer />
            </LocaleProvider>
          </APIErrorProvider>
        </AuthContextProvider>
        {/* </Suspense> */}
      </BrowserRouter>
    );
  }
}

export default App;
